module.exports = __webpack_public_path__ + "img/a8_06.ad4b1ec2.jpg";